/**
 * UsageWarnBanner — soft-warn banner at ≥80% LLM quota.
 *
 * Visibility decisions (threshold check, sessionStorage dismiss) live in the
 * caller (ChatBox). At 100% usage the caller hides this banner and the
 * UsageLimitModal (M3) takes over.
 */

import './UsageWarnBanner.css';

export type QuotaWindow = 'daily' | 'weekly';

export interface UsageWarnBannerProps {
  /** Pre-rounded integer percentage, 80–99 inclusive. */
  pct: number;
  /** Which window is at the higher utilization — drives the copy. */
  window: QuotaWindow;
  onUpgrade: () => void;
  onDismiss: () => void;
}

export function UsageWarnBanner({ pct, window: quotaWindow, onUpgrade, onDismiss }: UsageWarnBannerProps) {
  return (
    <div className="usage-warn-banner" role="status">
      <div className="usage-warn-banner-text">
        You've used <strong>{pct}%</strong> of your {quotaWindow} limit — upgrade for more
      </div>
      <div className="usage-warn-banner-actions">
        <button
          type="button"
          className="usage-warn-banner-btn usage-warn-banner-btn-upgrade"
          onClick={onUpgrade}
        >
          Upgrade
        </button>
        <button
          type="button"
          aria-label="Dismiss"
          className="usage-warn-banner-btn usage-warn-banner-btn-dismiss"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
    </div>
  );
}
